import Home from '../components/Home';
import IFramedRoutes from '../components/IFramedRoutes';

import QtyCalc from '../components/inventory/Inventory';
import PartLocator from '../components/inventory/PartLocator';
import PartInfo from '../components/inventory/PartInfo';
import StockAlarm from '../components/inventory/StockAlarm';
import PartProductHistory from '../components/inventory/PartProductHistory';
import WherePartIsUsed from '../components/inventory/WherePartIsUsed';
import DeepBomInfo from '../components/inventory/DeepBomInfo';
import BomKit from '../components/inventory/BomKit';
import BomKitDiff from '../components/inventory/BomKitDiff';
import PartEvaluator from '../components/inventory/PartEvaluator';
import ProductPricingSum from '../components/inventory/ProductPricingSum';
import InventoryCostReport from '../components/inventory/CostingReport';

import ShipmentLocator from '../components/sales-order/ShipmentLocator';
import ReportsAwaitingPayment from '../components/sales-order/reports/AwaitingPayment';
import OrderPipeline from '../components/sales-order/reports/OrderPipeline';
import SalesByLocation from '../components/sales-order/reports/SalesByLocation';
import HappyCustomerReport from '../components/sales-order/reports/HappyCustomerReport';
import LockedOrders from '../components/sales-order/reports/LockedOrders';
import OrdersWithProduct from '../components/sales-order/reports/OrdersWithProduct';
import Search from '../components/sales-order/view-order-2/OrderSearch';
import SearchResults from '../components/sales-order/search/SearchResults';
import ViewOrder from '../components/sales-order/view-order-2/ViewOrder';
import EditOrder from '../components/sales-order/edit-order-2/EditOrder';
import AllOrders from '../components/sales-order/AllOrders';
import BackorderedPartInfo from '../components/sales-order/BackorderedPartInfo';
import EmailNotifications from '../components/sales-order/EmailNotifications';
import InventoryRequest from '../components/sales-order/inventory-request/InventoryRequestOrder';

import RMAHC from '../components/rma-hc/RmaHc';
import BatchRmaHc from '../components/rma-hc/BatchRmaHc';
import RmaPendingApproval from '../components/rma-hc/RmaPendingApproval';
import RmaPendingReceive from '../components/rma-hc/RmaPendingReceive';

import AuditLog from '../components/audit/AuditLog';
import CHAMPTasks from '../components/it-info/CHAMPTasks';
import QueryPassthrough from '../components/it-info/QueryPassthrough';
import PackAndShip from '../components/pack-and-ship/PackAndShip';
import PackAndShip2 from '../components/pack-and-ship/PackAndShip2';
import CoffeeNotifier from '../components/office-info/CoffeeNotifier';

import SalesData from '../components/purchasing/SalesData';
import SalesSummary from '../components/purchasing/SalesSummary';
import PurchasingHistory from '../components/purchasing/PurchasingHistory';
import BuySheet from '../components/purchasing/BuySheet';
import PoReport from '../components/purchasing/PoReport';
import PastDueReport from '../components/purchasing/PastDueReport';
import PricingMarginReport from '../components/purchasing/PricingMarginReport';
import BomKitRecipe from '../components/purchasing/BomKitRecipe';

import TariffCodes from '../components/ops-info/TariffCodes';
import AdvIneligible from '../components/ops-info/AdvIneligible';
import OpsReport from '../components/ops-info/OpsReport';
import FCOpsReport from '../components/ops-info/FCOpsReport';
import InventoryWatcher from '../components/ops-info/InventoryWatcher';
import LargeItemShipping from '../components/ops-info/LargeItemShipping'
import FedExMargins from '../components/ops-info/FedExMargins';
import TrackingNumberEntry from '../components/ops-info/TrackingNumberEntry';
import ShippingServerBoxes from '../components/ops-info/ShippingServerBoxes.vue';

import MfgRequestProcess from '../components/mfg-info/MfgRequestProcess';
import RouterSchedule from '../components/mfg-info/RouterSchedule';
import HaasSchedule from '../components/mfg-info/HaasSchedule';
import DoosanSchedule from '../components/mfg-info/DoosanSchedule';
import NCSchedule from '../components/mfg-info/NCSchedule';
import MachineUptime from '../components/mfg-info/MachineUptime';

import CustomerLookup from '../components/customers/CustomerLookup';
import TaxTodo from '../components/customers/TaxTodo';
import FishbowlData from '../components/FishbowlData';

export default [
  { path: '/', name: 'Home', component: Home },
  { path: '/old-info/:route', name: 'IFramedRoutes', component: IFramedRoutes },

  { path: '/inventory/qty-calculations', name: 'Qty Calculations', component: QtyCalc },
  { path: '/inventory/part-locator', name: 'Part Locator', component: PartLocator },
  { path: '/inventory/bom-kit', name: 'BOM KIT Info', component: BomKit },
  { path: '/inventory/bom-kit-diff', name: 'BOM KIT Diff', component: BomKitDiff },
  { path: '/inventory/part-info', name: 'Part Info', component: PartInfo },
  { path: '/inventory/stock-alarm-report', name: 'Stock Alarm Products', component: StockAlarm },
  { path: '/inventory/part-product-history-report', name: 'Part/Product History', component: PartProductHistory },
  { path: '/inventory/where-part-is-used', name: 'Where Part Is Used', component: WherePartIsUsed },
  { path: '/inventory/deep-bom-info', name: 'Deep BOM Info', component: DeepBomInfo },
  { path: '/inventory/product-pricing-sum', name: 'Product Pricing Sums', component: ProductPricingSum },
  { path: '/inventory/costing-report', name: 'Inventory Costing Report', component: InventoryCostReport },

  { path: '/sales-order/reports/awaiting-payment', name: 'Awaiting Payment Report', component: ReportsAwaitingPayment },
  { path: '/sales-order/reports/pipeline', name: 'Order Pipeline', component: OrderPipeline },
  { path: '/sales-order/reports/by-location', name: 'Sales by Location', component: SalesByLocation },
  { path: '/sales-order/reports/happy-customer', name: 'Happy Customer Report', component: HappyCustomerReport },
  { path: '/sales-order/edit/:id', name: 'Edit Order', component: EditOrder },
  { path: '/sales-order/all', name: 'All Orders', component: AllOrders },
  { path: '/sales-order/search', name: 'Search', component: Search, meta: { title: "Order Search" } },
  { path: '/sales-order/search-results', name: 'Search Results', component: SearchResults },
  { path: '/sales-order/view/:id', name: 'View Order', component: ViewOrder, meta: { title: "Order View"} },
  { path: '/sales-order/email-notifications', name: 'Notifications', component: EmailNotifications },
  { path: '/sales-order/shipment-locator', name: 'Shipment Locator', component: ShipmentLocator },
  { path: '/sales-order/backordered-part-info', name: 'Backordered Part Info', component: BackorderedPartInfo },
  { path: '/sales-order', name: 'SO', component: Search },
  { path: '/sales-order/backordered-info', name: 'Backordered Info', component: BackorderedPartInfo },
  { path: '/sales-order/locked', name: 'Locked Orders', component: LockedOrders },

  { path: '/rmahc/:id', name: 'RMA HC', component: RMAHC },
  { path: '/batch-rmahc', name: 'Batch RMA HC', component: BatchRmaHc },
  { path: '/rma-pending-approval', name: 'RMA Pending Approval', component: RmaPendingApproval },
  { path: '/rma-pending-receive', name: 'RMA Pending Receive', component: RmaPendingReceive },

  { path: '/ops-info/tariff-codes', name: 'Tariff Codes', component: TariffCodes },
  { path: '/ops-info/adv-ineligible', name: 'ADV Ineligible', component: AdvIneligible },
  { path: '/ops-info/Ops', name: 'Operations Report', component: OpsReport },
  { path: '/ops-info/FCOps', name: 'FIRST Choice Operations Report', component: FCOpsReport },
  { path: '/ops-info/inv-request', name: 'Inventory Request', component: InventoryRequest },
  { path: '/ops-info/inv-watcher', name: 'Inventory Watcher', component: InventoryWatcher },
  { path: '/ops-info/large-item-shipping', name: 'Large Item Shipping', component: LargeItemShipping },
  { path: '/ops-info/fedex-margins', name: 'FedEx Margin Report', component: FedExMargins },
  { path: '/ops-info/tracking-number-entry', name: 'Tracking Number Entry', component: TrackingNumberEntry },
  { path: '/ops-info/shipping-server-boxes', name: 'Shipping Server Boxes', component: ShippingServerBoxes },

  { path: '/mfg-info/mfg-request-process', name: 'Manufacturing Request Process', component: MfgRequestProcess },
  { path: '/mfg-info/router-schedule', name: 'Router Schedule', component: RouterSchedule },
  { path: '/mfg-info/haas-schedule', name: 'Haas Schedule', component: HaasSchedule },
  { path: '/mfg-info/doosan-schedule', name: 'Doosan Schedule', component: DoosanSchedule },
  { path: '/mfg-info/nc-saw-schedule', name: 'NC Saw Schedule', component: NCSchedule },
  { path: '/mfg-info/machine-uptime', name: 'Machine Uptime', component: MachineUptime },

  { path: '/log', name: 'AuditLog', component: AuditLog },
  { path: '/log/:sonum', name: 'OrderAuditLog', component: AuditLog },

  //{ path: '/pack-and-ship', name: 'PackAndShip', component: PackAndShip },
  { path: '/pack-and-ship', name: 'PackAndShip2', component: PackAndShip2 },
  { path: '/coffee-notifier', name: 'CoffeeNotifier', component: CoffeeNotifier },

  { path: '/purchasing/sales-data', name: 'Sales Data', component: SalesData },
  { path: '/purchasing/sales-summary', name: 'Sales Summary', component: SalesSummary },
  { path: '/purchasing/orders-with-product', name: 'Orders with Product', component: OrdersWithProduct },
  { path: '/purchasing/purchasing-history', name: 'Purchasing History', component: PurchasingHistory },
  { path: '/purchasing/buy-sheet', name: 'Buy Sheet', component: BuySheet },
  { path: '/purchasing/pricing-margin-report', name: 'Pricing Margin Report', component: PricingMarginReport },
  { path: '/purchasing/part-evaluator', name: 'Part Evaluator', component: PartEvaluator },
  { path: '/purchasing/po-report', name: 'PO Report', component: PoReport },
  { path: '/purchasing/past-due-report', name: 'Past Due Report', component: PastDueReport },
  { path: '/purchasing/bom-kit-recipe', name: 'BOM/Kit Recipe', component: BomKitRecipe },

  { path: '/it-info/champ-tasks', name: 'CHAMP Tasks', component: CHAMPTasks },
  { path: '/it-info/query-passthrough', name: 'Query Passthrough', component: QueryPassthrough },

  { path: '/customers', name: 'Customer Lookup', component: CustomerLookup },
  { path: '/customers/tax-todo', name: 'Unapproved Tax Forms', component: TaxTodo },
  { path: '/fishbowl-data', name: 'Fishbowl Data', component: FishbowlData },
];



// WEBPACK FOOTER //
// /src/router/routes.js